/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceDraftMergeOperation } from "./SpaceDraftMergeOperation";
export const SpaceDraftMergeOperations = core.serialization.object({
    space: core.serialization.list(SpaceDraftMergeOperation),
    workbook: core.serialization.list(SpaceDraftMergeOperation),
    sheet: core.serialization.list(SpaceDraftMergeOperation),
    guidance: core.serialization.list(SpaceDraftMergeOperation),
    document: core.serialization.list(SpaceDraftMergeOperation),
    action: core.serialization.list(SpaceDraftMergeOperation),
    agent: core.serialization.list(SpaceDraftMergeOperation),
});
